var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgEquippedCheck = function SvgEquippedCheck(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#4ABF54",
    d: "M14 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFF5B9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 10.286 12.8 12 17 8"
  })));
};
export default SvgEquippedCheck;